"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _urlSearchParams = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url-search-params"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _lodash = _interopRequireDefault(require("lodash"));
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _BouncerProvider = _interopRequireDefault(require("@/libs/BouncerProvider"));
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var log = _Logger.default.namespace('Welcome.vue');
var _default = {
  components: {
    Captcha: _Captcha.default,
    StartupLayout: _CommonLayout.default
  },
  props: {
    resumeStartup: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    var _context;
    return {
      connectErrors: [],
      resumePending: false,
      // The resume reuses a network Kiwi restored from saved state rather than a new one.
      resumeNetworkRestored: false,
      resumeError: '',
      network: null,
      channel: '',
      nick: '',
      password: '',
      showChannel: true,
      showPass: true,
      // showMoreInfo: false, // This was the original data name, updated below
      toggablePass: true,
      showNick: true,
      show_password_box: false,
      connectWithoutChannel: false,
      showPlainText: false,
      captchaReady: false,
      termsAccepted: false,
      // MODIFIED: New data properties
      showMoreInfo: false,
      gender: '',
      age: null,
      provincia: '',
      showBanner: true,
      bannerHasAd: false,
      welcomeAdZone: '9f73a40c-0d64-45ad-93a3-b95d41b554f3',
      welcomeAdBase: 'https://ads.eggload.com',
      welcomeAdRefreshTimer: null,
      welcomeAdReshowTimer: null,
      welcomeAdLoading: false,
      provinceItaliane: (0, _sort.default)(_context = [{
        text: 'Agrigento',
        value: 'AG'
      }, {
        text: 'Alessandria',
        value: 'AL'
      }, {
        text: 'Ancona',
        value: 'AN'
      }, {
        text: 'Aosta',
        value: 'AO'
      }, {
        text: 'Arezzo',
        value: 'AR'
      }, {
        text: 'Ascoli Piceno',
        value: 'AP'
      }, {
        text: 'Asti',
        value: 'AT'
      }, {
        text: 'Avellino',
        value: 'AV'
      }, {
        text: 'Bari',
        value: 'BA'
      }, {
        text: 'Barletta-Andria-Trani',
        value: 'BT'
      }, {
        text: 'Belluno',
        value: 'BL'
      }, {
        text: 'Benevento',
        value: 'BN'
      }, {
        text: 'Bergamo',
        value: 'BG'
      }, {
        text: 'Biella',
        value: 'BI'
      }, {
        text: 'Bologna',
        value: 'BO'
      }, {
        text: 'Bolzano',
        value: 'BZ'
      }, {
        text: 'Brescia',
        value: 'BS'
      }, {
        text: 'Brindisi',
        value: 'BR'
      }, {
        text: 'Cagliari',
        value: 'CA'
      }, {
        text: 'Caltanissetta',
        value: 'CL'
      }, {
        text: 'Campobasso',
        value: 'CB'
      }, {
        text: 'Caserta',
        value: 'CE'
      }, {
        text: 'Catania',
        value: 'CT'
      }, {
        text: 'Catanzaro',
        value: 'CZ'
      }, {
        text: 'Chieti',
        value: 'CH'
      }, {
        text: 'Como',
        value: 'CO'
      }, {
        text: 'Cosenza',
        value: 'CS'
      }, {
        text: 'Cremona',
        value: 'CR'
      }, {
        text: 'Crotone',
        value: 'KR'
      }, {
        text: 'Cuneo',
        value: 'CN'
      }, {
        text: 'Enna',
        value: 'EN'
      }, {
        text: 'Fermo',
        value: 'FM'
      }, {
        text: 'Ferrara',
        value: 'FE'
      }, {
        text: 'Firenze',
        value: 'FI'
      }, {
        text: 'Foggia',
        value: 'FG'
      }, {
        text: 'Forlì-Cesena',
        value: 'FC'
      }, {
        text: 'Frosinone',
        value: 'FR'
      }, {
        text: 'Genova',
        value: 'GE'
      }, {
        text: 'Gorizia',
        value: 'GO'
      }, {
        text: 'Grosseto',
        value: 'GR'
      }, {
        text: 'Imperia',
        value: 'IM'
      }, {
        text: 'Isernia',
        value: 'IS'
      }, {
        text: 'La Spezia',
        value: 'SP'
      }, {
        text: 'L\'Aquila',
        value: 'AQ'
      }, {
        text: 'Latina',
        value: 'LT'
      }, {
        text: 'Lecce',
        value: 'LE'
      }, {
        text: 'Lecco',
        value: 'LC'
      }, {
        text: 'Livorno',
        value: 'LI'
      }, {
        text: 'Lodi',
        value: 'LO'
      }, {
        text: 'Lucca',
        value: 'LU'
      }, {
        text: 'Macerata',
        value: 'MC'
      }, {
        text: 'Mantova',
        value: 'MN'
      }, {
        text: 'Massa-Carrara',
        value: 'MS'
      }, {
        text: 'Matera',
        value: 'MT'
      }, {
        text: 'Medio Campidano',
        value: 'VS'
      }, {
        text: 'Messina',
        value: 'ME'
      }, {
        text: 'Milano',
        value: 'MI'
      }, {
        text: 'Modena',
        value: 'MO'
      }, {
        text: 'Monza-Brianza',
        value: 'MB'
      }, {
        text: 'Napoli',
        value: 'NA'
      }, {
        text: 'Novara',
        value: 'NO'
      }, {
        text: 'Nuoro',
        value: 'NU'
      }, {
        text: 'Ogliastra',
        value: 'OG'
      }, {
        text: 'Olbia-Tempio',
        value: 'OT'
      }, {
        text: 'Oristano',
        value: 'OR'
      }, {
        text: 'Padova',
        value: 'PD'
      }, {
        text: 'Palermo',
        value: 'PA'
      }, {
        text: 'Parma',
        value: 'PR'
      }, {
        text: 'Pavia',
        value: 'PV'
      }, {
        text: 'Perugia',
        value: 'PG'
      }, {
        text: 'Pesaro e Urbino',
        value: 'PU'
      }, {
        text: 'Pescara',
        value: 'PE'
      }, {
        text: 'Piacenza',
        value: 'PC'
      }, {
        text: 'Pisa',
        value: 'PI'
      }, {
        text: 'Pistoia',
        value: 'PT'
      }, {
        text: 'Pordenone',
        value: 'PN'
      }, {
        text: 'Potenza',
        value: 'PZ'
      }, {
        text: 'Prato',
        value: 'PO'
      }, {
        text: 'Ragusa',
        value: 'RG'
      }, {
        text: 'Ravenna',
        value: 'RA'
      }, {
        text: 'Reggio Calabria',
        value: 'RC'
      }, {
        text: 'Reggio Emilia',
        value: 'RE'
      }, {
        text: 'Rieti',
        value: 'RI'
      }, {
        text: 'Rimini',
        value: 'RN'
      }, {
        text: 'Roma',
        value: 'RM'
      }, {
        text: 'Rovigo',
        value: 'RO'
      }, {
        text: 'Salerno',
        value: 'SA'
      }, {
        text: 'Sassari',
        value: 'SS'
      }, {
        text: 'Savona',
        value: 'SV'
      }, {
        text: 'Siena',
        value: 'SI'
      }, {
        text: 'Siracusa',
        value: 'SR'
      }, {
        text: 'Sondrio',
        value: 'SO'
      }, {
        text: 'Sud Sardegna',
        value: 'SU'
      },
      // Nuova provincia
      {
        text: 'Taranto',
        value: 'TA'
      }, {
        text: 'Teramo',
        value: 'TE'
      }, {
        text: 'Terni',
        value: 'TR'
      }, {
        text: 'Torino',
        value: 'TO'
      }, {
        text: 'Trapani',
        value: 'TP'
      }, {
        text: 'Trento',
        value: 'TN'
      }, {
        text: 'Treviso',
        value: 'TV'
      }, {
        text: 'Trieste',
        value: 'TS'
      }, {
        text: 'Udine',
        value: 'UD'
      }, {
        text: 'Varese',
        value: 'VA'
      }, {
        text: 'Venezia',
        value: 'VE'
      }, {
        text: 'Verbano-Cusio-Ossola',
        value: 'VB'
      }, {
        text: 'Vercelli',
        value: 'VC'
      }, {
        text: 'Verona',
        value: 'VR'
      }, {
        text: 'Vibo Valentia',
        value: 'VV'
      }, {
        text: 'Vicenza',
        value: 'VI'
      }, {
        text: 'Viterbo',
        value: 'VT'
      }]).call(_context, function (a, b) {
        return a.text.localeCompare(b.text);
      }) // Sort provinces alphabetically
      // END MODIFICATION
    };
  },

  computed: {
    // Added by me
    showExtraMessage: function showExtraMessage() {
      return !this.gender || !this.age || !this.provincia || this.gender === 'U' || this.provincia === 'UU';
    },
    // End added by me
    isIframe: function isIframe() {
      return !(window === window.parent || window.opener);
    },
    startupOptions: function startupOptions() {
      return this.$state.settings.startupOptions;
    },
    greetingText: function greetingText() {
      var greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    footerText: function footerText() {
      var footer = this.$state.settings.startupOptions.footerText;
      return typeof footer === 'string' ? footer : '';
    },
    termsContent: function termsContent() {
      var terms = this.$state.settings.startupOptions.termsContent;
      return typeof terms === 'string' ? terms : '';
    },
    buttonText: function buttonText() {
      var greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    isNickValid: function isNickValid() {
      if (Misc.isNickValidationException(this.nick)) {
        return true;
      }
      var nickPatternStr = this.$state.setting('startupOptions.nick_format');
      var nickPattern = '';
      if (!nickPatternStr) {
        // Nicks cannot start with [0-9- ]
        // ? is not a valid nick character but we allow it as it gets replaced
        // with a number. Digits are only allowed at the end of the nick.
        nickPattern = /^[a-z_\\[\]{}^`|][a-z?_\-\\[\]{}^`|]*\d*$/i;
      } else {
        // Support custom pattern matches. Eg. only '@example.com' may be allowed
        // on some IRCDs
        var pattern = '';
        var flags = '';
        if (nickPatternStr[0] === '/') {
          // Custom regex
          var pos = nickPatternStr.lastIndexOf('/');
          pattern = nickPatternStr.substring(1, pos);
          flags = nickPatternStr.substr(pos + 1);
        } else {
          // Basic contains rule
          pattern = _lodash.default.escapeRegExp(nickPatternStr);
          flags = 'i';
        }
        try {
          nickPattern = new RegExp(pattern, flags);
        } catch (error) {
          log.error('Nick format error: ' + error.message);
          return false;
        }
      }
      return this.nick.match(nickPattern);
    },
    readyToStart: function readyToStart() {
      var ready = !!this.nick;
      if (!this.connectWithoutChannel && !this.channel) {
        ready = false;
      }

      // Make sure the channel name starts with a common channel prefix
      if (!this.connectWithoutChannel) {
        var bufferObjs = Misc.extractBuffers(this.channel);
        bufferObjs.forEach(function (bufferObj) {
          if ('#&'.indexOf(bufferObj.name[0]) === -1) {
            ready = false;
          }
        });
      }

      // If toggling the password is is disabled, assume it is required
      if (!this.toggablePass && !this.password) {
        ready = false;
      }
      if (!this.isNickValid) {
        ready = false;
      }
      if (this.termsContent && !this.termsAccepted) {
        ready = false;
      }

      // TODO: If showMoreInfo is true, you might want to add validation for new fields here
      // For example:
      // if (this.showMoreInfo && (!this.gender ...)) {
      //     ready = false;
      // }

      return ready;
    }
  },
  watch: {
    show_password_box: function show_password_box(newVal) {
      if (newVal === false) {
        // clear the password when show password is unchecked
        this.password = '';
      }
    },
    showMoreInfo: function showMoreInfo(newVal) {
      if (!newVal) {
        // Clear the cookies when showMoreInfo is turned off
        this.saveUserInfoToCookies();
      }
    }
  },
  created: function created() {
    var _context2,
      _this = this;
    var options = this.startupOptions;
    var connectOptions = this.connectOptions();

    // Take some settings from a previous network if available
    var previousNet = null;
    if ((0, _trim.default)(_context2 = connectOptions.hostname).call(_context2)) {
      var _context3;
      previousNet = this.$state.getNetworkFromAddress((0, _trim.default)(_context3 = connectOptions.hostname).call(_context3));
    }
    if (Misc.queryStringVal('nick')) {
      this.nick = Misc.queryStringVal('nick');
    } else if (previousNet && previousNet.connection.nick) {
      this.nick = previousNet.connection.nick;
    } else {
      this.nick = options.nick;
    }
    this.nick = this.processNickRandomNumber(this.nick || '');
    if (options.password) {
      this.password = options.password;
    } else if (previousNet && previousNet.password) {
      this.password = previousNet.password;
      this.show_password_box = true;
    } else {
      this.password = '';
    }
    this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
    this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
    this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
    this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
    this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;
    this.connectWithoutChannel = !!options.allowNoChannel;
    if (options.bouncer) {
      this.toggablePass = false;
      this.showPass = true;
      this.showChannel = false;
      this.connectWithoutChannel = true;
      var bouncer = new _BouncerProvider.default(this.$state);
      bouncer.enable(connectOptions.hostname, connectOptions.port, connectOptions.tls, connectOptions.direct, connectOptions.direct_path);
    }
    this.loadUserInfoFromCookies();
    if (this.resumeStartup) {
      this.nick = this.resumeStartup.nick;
      this.resumePending = true;
      this.$nextTick(function () {
        return _this.startupResumeConnect();
      });
    } else if (options.autoConnect && this.readyToStart) {
      this.startUp();
    }

    // Start welcome ad fetch ASAP (do not wait for ads plugin).
    if (!this.resumeStartup) {
      this.$nextTick(function () {
        _this.initWelcomeAd();
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cancelStartupResume(true);
    if (this.stopWaitingForRegistration) {
      this.stopWaitingForRegistration();
    }
    if (this.welcomeAdRefreshTimer) {
      clearInterval(this.welcomeAdRefreshTimer);
      this.welcomeAdRefreshTimer = null;
    }
    if (this.welcomeAdReshowTimer) {
      clearTimeout(this.welcomeAdReshowTimer);
      this.welcomeAdReshowTimer = null;
    }
  },
  methods: {
    isWelcomeAdDismissed: function isWelcomeAdDismissed() {
      try {
        var until = parseInt(sessionStorage.getItem('adnet_dismiss_welcome') || '0', 10);
        return until > Date.now();
      } catch (e) {
        return false;
      }
    },
    getWelcomeAdTags: function getWelcomeAdTags() {
      var tags = [];
      try {
        if (window.localStorage.getItem('over18') === 'true') {
          tags.push('over18');
        }
      } catch (e) {/* ignore */}
      return tags;
    },
    getWelcomeAdSeen: function getWelcomeAdSeen() {
      try {
        return JSON.parse(sessionStorage.getItem('adnet_seen_' + this.welcomeAdZone) || '[]');
      } catch (e) {
        return [];
      }
    },
    addWelcomeAdSeen: function addWelcomeAdSeen(adId) {
      if (!adId) return;
      var seen = this.getWelcomeAdSeen();
      if (seen.indexOf(adId) === -1) {
        seen.push(adId);
        try {
          sessionStorage.setItem('adnet_seen_' + this.welcomeAdZone, (0, _stringify.default)((0, _slice.default)(seen).call(seen, -20)));
        } catch (e) {/* ignore */}
      }
    },
    initWelcomeAd: function initWelcomeAd() {
      var _this2 = this;
      if (this.isWelcomeAdDismissed()) {
        this.showBanner = false;
        this.bannerHasAd = false;
        var until = parseInt(sessionStorage.getItem('adnet_dismiss_welcome') || '0', 10);
        var delay = Math.max(1000, until - Date.now());
        this.welcomeAdReshowTimer = setTimeout(function () {
          try {
            sessionStorage.removeItem('adnet_dismiss_welcome');
          } catch (e) {/* ignore */}
          _this2.showBanner = true;
          _this2.loadWelcomeAd();
          _this2.welcomeAdRefreshTimer = setInterval(function () {
            return _this2.loadWelcomeAd();
          }, 60000);
        }, delay);
        return;
      }
      this.loadWelcomeAd();
      if (!this.welcomeAdRefreshTimer) {
        this.welcomeAdRefreshTimer = setInterval(function () {
          return _this2.loadWelcomeAd();
        }, 60000);
      }
    },
    loadWelcomeAd: function loadWelcomeAd() {
      var _this3 = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var el, seen, tags, url, r, text, ad, a, img;
        return _regenerator.default.wrap(function _callee$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_this3.welcomeAdLoading || document.hidden || _this3.isWelcomeAdDismissed())) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              el = _this3.$refs.welcomeAdSlot;
              if (el) {
                _context4.next = 6;
                break;
              }
              _this3.$nextTick(function () {
                return _this3.loadWelcomeAd();
              });
              return _context4.abrupt("return");
            case 6:
              _this3.welcomeAdLoading = true;
              _context4.prev = 7;
              seen = _this3.getWelcomeAdSeen();
              tags = _this3.getWelcomeAdTags();
              url = _this3.welcomeAdBase + '/api/ads/serve?zone=' + encodeURIComponent(_this3.welcomeAdZone);
              if (seen.length) {
                url += '&seen=' + encodeURIComponent(seen.join(','));
              }
              if (tags.length) {
                url += '&tags=' + encodeURIComponent(tags.join(','));
              }
              _context4.next = 15;
              return fetch(url, {
                credentials: 'omit'
              });
            case 15:
              r = _context4.sent;
              if (!(!r.ok || r.status === 204 || r.status !== 200)) {
                _context4.next = 19;
                break;
              }
              _this3.bannerHasAd = false;
              return _context4.abrupt("return");
            case 19:
              _context4.next = 21;
              return r.text();
            case 21:
              text = _context4.sent;
              if (!(!text || !(0, _trim.default)(text).call(text))) {
                _context4.next = 25;
                break;
              }
              _this3.bannerHasAd = false;
              return _context4.abrupt("return");
            case 25:
              _context4.prev = 25;
              ad = JSON.parse(text);
              _context4.next = 33;
              break;
            case 29:
              _context4.prev = 29;
              _context4.t0 = _context4["catch"](25);
              _this3.bannerHasAd = false;
              return _context4.abrupt("return");
            case 33:
              if (!(!ad || !ad.type)) {
                _context4.next = 36;
                break;
              }
              _this3.bannerHasAd = false;
              return _context4.abrupt("return");
            case 36:
              _this3.addWelcomeAdSeen(ad.adId);
              a = document.createElement('a');
              a.href = ad.clickUrl;
              a.target = '_blank';
              a.rel = 'noopener noreferrer nofollow';
              if (ad.type === 'banner' && ad.imageUrl) {
                img = document.createElement('img');
                img.src = ad.imageUrl;
                img.alt = ad.title || '';
                img.referrerPolicy = 'no-referrer';
                img.decoding = 'async';
                img.style.maxWidth = '100%';
                img.style.display = 'block';
                img.style.margin = '0 auto';
                a.appendChild(img);
              } else {
                a.textContent = ad.title || '';
              }
              if (el.replaceChildren) {
                el.replaceChildren(a);
              } else {
                el.innerHTML = '';
                el.appendChild(a);
              }
              _this3.bannerHasAd = true;
              _this3.showBanner = true;
              _context4.next = 50;
              break;
            case 47:
              _context4.prev = 47;
              _context4.t1 = _context4["catch"](7);
              _this3.bannerHasAd = false;
            case 50:
              _context4.prev = 50;
              _this3.welcomeAdLoading = false;
              return _context4.finish(50);
            case 53:
            case "end":
              return _context4.stop();
          }
        }, _callee, null, [[7, 47, 50, 53], [25, 29]]);
      }))();
    },
    closeWelcomeBanner: function closeWelcomeBanner() {
      var _this4 = this;
      this.showBanner = false;
      this.bannerHasAd = false;
      try {
        sessionStorage.setItem('adnet_dismiss_welcome', String(Date.now() + 13 * 60 * 1000));
      } catch (e) {/* ignore */}
      if (this.welcomeAdRefreshTimer) {
        clearInterval(this.welcomeAdRefreshTimer);
        this.welcomeAdRefreshTimer = null;
      }
      if (this.welcomeAdReshowTimer) {
        clearTimeout(this.welcomeAdReshowTimer);
      }
      this.welcomeAdReshowTimer = setTimeout(function () {
        try {
          sessionStorage.removeItem('adnet_dismiss_welcome');
        } catch (e) {/* ignore */}
        _this4.showBanner = true;
        _this4.loadWelcomeAd();
        _this4.welcomeAdRefreshTimer = setInterval(function () {
          return _this4.loadWelcomeAd();
        }, 60000);
      }, 13 * 60 * 1000);
    },
    onAltClose: function onAltClose(event) {
      if (event.channel) {
        this.channel = event.channel;
      }
      if (event.nick) {
        this.nick = event.nick;
      }
      if (event.password) {
        this.password = event.password;
      }
      if (event.error) {
        this.connectErrors.push(event.error);
      }
      this.$state.settings.startupOptions.altComponent = null;
    },
    readableStateError: function readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit: function formSubmit() {
      if (this.readyToStart) {
        this.saveUserInfoToCookies();
        this.startUp();
      }
    },
    guid: function guid() {
      var _context5, _context6, _context7, _context8, _context9, _context10, _context11;
      var s4 = function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      };
      return (0, _concat.default)(_context5 = (0, _concat.default)(_context6 = (0, _concat.default)(_context7 = (0, _concat.default)(_context8 = (0, _concat.default)(_context9 = (0, _concat.default)(_context10 = (0, _concat.default)(_context11 = "".concat(s4())).call(_context11, s4())).call(_context10, s4())).call(_context9, s4())).call(_context8, s4())).call(_context7, s4())).call(_context6, s4())).call(_context5, s4());
    },
    createCookie: function createCookie(name, value, days) {
      var _context12, _context13;
      var expires = '';
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=".concat(date.toGMTString());
      }
      document.cookie = (0, _concat.default)(_context12 = (0, _concat.default)(_context13 = "".concat(name, "=")).call(_context13, value)).call(_context12, expires, "; SameSite=Strict; path=/");
    },
    readCookie: function readCookie(name) {
      var _context14;
      var nameEQ = "".concat(name, "=");
      var ca = (0, _map.default)(_context14 = document.cookie.split(';')).call(_context14, function (cookie) {
        return (0, _trim.default)(cookie).call(cookie);
      });
      var foundCookie = (0, _find.default)(ca).call(ca, function (cookie) {
        return cookie.indexOf(nameEQ) === 0;
      });
      return foundCookie ? foundCookie.substring(nameEQ.length) : null;
    },
    getSHA: function getSHA(username) {
      var hash = _cryptoJs.default.SHA1(username);
      var hexHash = hash.toString(_cryptoJs.default.enc.Hex);
      return hexHash.substring(10, 25);
    },
    currentUrlParts: function currentUrlParts() {
      var search = window.location.search;
      var pathname = window.location.pathname;
      try {
        var parentLocation = window.top.location;
        search = parentLocation.search;
        pathname = parentLocation.pathname;
      } catch (err) {
        // Cross-origin parents cannot expose location; use this frame's URL.
      }
      return {
        search: search,
        pathname: pathname
      };
    },
    readRequestIdent: function readRequestIdent() {
      try {
        return new _urlSearchParams.default(this.currentUrlParts().search).get('req');
      } catch (err) {
        return null;
      }
    },
    updateRequestIdentUrl: function updateRequestIdentUrl(myident) {
      try {
        var _context15;
        var _this$currentUrlParts = this.currentUrlParts(),
          search = _this$currentUrlParts.search,
          pathname = _this$currentUrlParts.pathname;
        var searchParams = new _urlSearchParams.default(search);
        searchParams.set('req', myident);
        // eslint-disable-next-line no-restricted-globals
        history.replaceState(null, '', (0, _concat.default)(_context15 = "".concat(pathname, "?")).call(_context15, searchParams.toString()));
      } catch (err) {
        // URL decoration is optional in embedded and constrained browsing contexts.
      }
    },
    cancelStartupResume: function cancelStartupResume() {
      var destroying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.resumePending) {
        return;
      }
      if (this.resumeStartup && this.resumeStartup.cancel) {
        this.resumeStartup.cancel(this.network);
      }
      if (this.network) {
        this.releaseResumeNetwork(this.network);
      }
      this.resumePending = false;
      if (!destroying) {
        this.resumeError = '';
      }
    },
    /**
     * Ends a resume that did not complete. Only a network created for it is removed: one Kiwi
     * restored keeps its saved settings (the password Welcome prefills from, nick, buffers).
     */
    releaseResumeNetwork: function releaseResumeNetwork(net) {
      net.gatewayResumeStartup = false;
      if (!this.resumeNetworkRestored) {
        this.$state.removeNetwork(net.id);
      }
      this.resumeNetworkRestored = false;
      this.network = null;
    },
    startupResumeConnect: function startupResumeConnect() {
      if (!this.resumeStartup || !this.resumePending) {
        return;
      }
      // startUp() sends neither the password nor the channels on a resume. The form keeps
      // them, so a resume that fails shows the prefilled form again.
      this.startUp();
    },
    startUp: function startUp() {
      var _this5 = this;
      this.connectErrors = [];
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = this.connectOptions();
      var netAddress = (0, _trim.default)(_lodash.default).call(_lodash.default, connectOptions.hostname);

      // Check if we have this network already
      var net = this.network || this.$state.getNetworkFromAddress(netAddress);
      this.resumeNetworkRestored = this.resumePending && !!net;

      // A resume restores the held session as it was: no credentials, no new joins.
      var resuming = this.resumePending;
      var password = resuming ? '' : this.password;
      var myident = this.readCookie('myident');
      if (!myident) {
        myident = this.readRequestIdent() || this.guid().substring(0, 10);
        this.createCookie('myident', myident, 7);
      }
      this.updateRequestIdentUrl(myident);
      var gecosParts = [];
      if (this.showMoreInfo) {
        if (this.gender) gecosParts.push("".concat(this.normalizeGender(this.gender)));
        if (this.age) gecosParts.push("".concat(this.age));
        if (this.provincia) gecosParts.push("".concat(this.provincia));
      }
      var gecos = gecosParts.join('');
      net = net || this.$state.addNetwork('Network', this.nick, {
        server: netAddress,
        port: connectOptions.port,
        tls: connectOptions.tls,
        password: password,
        encoding: (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding),
        direct: connectOptions.direct,
        path: connectOptions.direct_path || '',
        gecos: gecos + '_' + this.getSHA(myident),
        username: myident
      });

      // Clear the server buffer in case it already existed and contains messages relating to
      // the previous connection, such as errors. They are now redundant since this is a
      // new connection.
      net.serverBuffer().clearMessages();

      // If we retreived an existing network, update the nick+password with what
      // the user has just put in place
      net.connection.nick = this.nick;
      if (options.bouncer) {
        var _context16;
        // Bouncer mode uses server PASS
        net.connection.password = (0, _concat.default)(_context16 = "".concat(this.nick, ":")).call(_context16, password);
        net.password = '';
      } else {
        net.connection.password = '';
        // A startup resume connects without the form's password; it must not erase
        // the one saved with a network Kiwi restored, or the next Welcome loses it.
        if (!this.resumePending || password) {
          net.password = password;
        }
      }
      if ((0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding || '')) {
        net.connection.encoding = (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding);
      }
      this.network = net;
      if (this.resumePending) {
        net.gatewayResumeStartup = true;
        var prepared = this.resumeStartup.begin(net, {
          success: function success() {
            var _context17, _context18;
            net.gatewayResumeStartup = false;
            function hasReplayedQuery(buffer) {
              return !buffer.isChannel() && buffer.name !== '*' && buffer.latest_messages && buffer.latest_messages.length;
            }
            var queryBuffers = (0, _filter.default)(_context17 = net.buffers).call(_context17, hasReplayedQuery);
            function compareLatestMessages(left, right) {
              return right.latest_messages[0].time - left.latest_messages[0].time;
            }
            var replayedQuery = (0, _sort.default)(queryBuffers).call(queryBuffers, compareLatestMessages)[0];
            function isJoinedChannel(buffer) {
              return buffer.isChannel() && buffer.joined;
            }
            var joinedChannel = (0, _find.default)(_context18 = net.buffers).call(_context18, isJoinedChannel);
            var resumeBuffer = replayedQuery || joinedChannel;
            if (resumeBuffer) {
              _this5.$state.setActiveBuffer(net.id, resumeBuffer.name);
            }
            _this5.resumePending = false;
            if (_this5.$refs.layout) {
              _this5.$refs.layout.close();
            }
          },
          failure: function failure(message) {
            _this5.releaseResumeNetwork(net);
            _this5.resumePending = false;
            _this5.resumeError = message;
          }
        });
        if (!prepared) {
          this.releaseResumeNetwork(net);
          this.resumePending = false;
          this.resumeError = 'Could not prepare the saved session. Please connect again.';
          return;
        }
      }

      // Only switch to the first channel we join if multiple are being joined
      var hasSwitchedActiveBuffer = false;
      var bufferObjs = Misc.extractBuffers(resuming ? '' : this.channel);
      bufferObjs.forEach(function (bufferObj) {
        var newBuffer = _this5.$state.addBuffer(net.id, bufferObj.name);
        newBuffer.enabled = true;
        if (newBuffer && !hasSwitchedActiveBuffer) {
          _this5.$state.setActiveBuffer(net.id, newBuffer.name);
          hasSwitchedActiveBuffer = true;
        }
        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }
      });

      // switch to server buffer if no channels are joined
      if (!options.bouncer && !hasSwitchedActiveBuffer) {
        this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
      }

      // A close is not the end of this attempt: the gateway plugin retries and may fall back
      // to a direct connection. Keep waiting for registration until it happens, the form is
      // submitted again, or Welcome goes away.
      if (this.stopWaitingForRegistration) {
        this.stopWaitingForRegistration();
      }
      var onRegistered = function onRegistered() {
        if (!_this5.resumePending && _this5.$refs.layout) {
          _this5.$refs.layout.close();
        }
        stopWaiting();
      };
      var onClosed = function onClosed() {
        var _context19;
        var lastError = net.last_error;
        if (lastError && !(0, _includes.default)(_context19 = _this5.connectErrors).call(_context19, lastError)) {
          _this5.connectErrors.push(lastError);
        }
      };
      var onError = function onError(event) {
        var _context20;
        if (!event.reason || (0, _includes.default)(_context20 = _this5.connectErrors).call(_context20, event.reason)) {
          return;
        }
        _this5.connectErrors.push(event.reason);
      };
      var stopWaiting = function stopWaiting() {
        net.ircClient.off('registered', onRegistered);
        net.ircClient.off('close', onClosed);
        net.ircClient.off('irc error', onError);
        if (_this5.stopWaitingForRegistration === stopWaiting) {
          _this5.stopWaitingForRegistration = null;
        }
      };
      this.stopWaitingForRegistration = stopWaiting;
      net.ircClient.on('registered', onRegistered);
      net.ircClient.on('close', onClosed);
      net.ircClient.on('irc error', onError);
      net.ircClient.connect();
    },
    processNickRandomNumber: function processNickRandomNumber(nick) {
      // Replace ? with a random number
      var tmp = (nick || '').replace(/\?/g, function () {
        return Math.floor(Math.random() * 100).toString();
      });
      return (0, _trim.default)(_lodash.default).call(_lodash.default, tmp);
    },
    handleCaptcha: function handleCaptcha(isReady) {
      this.captchaReady = isReady;
    },
    connectOptions: function connectOptions() {
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = Misc.connectionInfoFromConfig(options);

      // If a server isn't specified in the config, set some defaults
      // The webircgateway will have a default network set and will connect
      // there instead. This just removes the requirement of specifying the same
      // irc network address in both the server-side and client side configs
      connectOptions.hostname = connectOptions.hostname || 'default';
      if (!connectOptions.port && connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 443 : 80;
      } else if (!connectOptions.port && !connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 6697 : 6667;
      }
      return connectOptions;
    },
    saveUserInfoToCookies: function saveUserInfoToCookies() {
      if (this.showMoreInfo) {
        this.createCookie('user_gender', this.normalizeGender(this.gender), 365);
        this.createCookie('user_age', this.age, 365);
        this.createCookie('user_provincia', this.provincia, 365);
        this.createCookie('show_more_info', 'true', 365);
      } else {
        // Clear the cookies if showMoreInfo is false
        this.createCookie('user_gender', '', -1);
        this.createCookie('user_age', '', -1);
        this.createCookie('user_provincia', '', -1);
        this.createCookie('show_more_info', '', -1);
      }
    },
    loadUserInfoFromCookies: function loadUserInfoFromCookies() {
      var showMoreInfo = this.readCookie('show_more_info') === 'true';
      if (showMoreInfo) {
        this.showMoreInfo = true;
        this.gender = this.normalizeGender(this.readCookie('user_gender')) || '';
        this.age = parseInt(this.readCookie('user_age'), 10) || null;
        this.provincia = this.readCookie('user_provincia') || '';
      }
    },
    normalizeGender: function normalizeGender(gender) {
      return gender === 'ALTRO' ? 'N' : gender;
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Welcome"]
window._kiwi_exports.components.startups.Welcome = exports.default ? exports.default : exports;
